import React, { Component, Fragment } from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import { toast } from 'react-toastify';

import { Loading } from "../components"

import api from "../services/api";

class ModalAtivacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isLoading: false,
      record: {}
    }
    this.closeModalActivation = props.closeModal
  }

  static getDerivedStateFromProps(props, state) {
    if (props.showModal !== state.showModal) {
      return {
        showModal: props.showModal,
        record: props.record
      };
    }
    return null;
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      isLoading: false,
      record: this.props.emptyRecord
    }, () => this.closeModalActivation());
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoading: true }, () => {
      api.post('/usuarios/ativacao', { id: this.state.record.idUsuario })
        .then((response) => {
          if (response.data.message === 'ok') {
            toast.success('Mensagem enviada com sucesso!');
            this.closeModal();
          } else {
            this.setState({ isLoading: false });
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          toast.error('Ocorreu uma falha ao tentar enviar a mansagem!');
        });
    });
  };

  render() {
    const { showModal, isLoading, record } = this.state;

    return (
      <Fragment>
        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Ativação de conta</Modal.Title>
          </Modal.Header>
          <div className="loading">
            <Modal.Body className="text-center">
              <h5>Confirma o envio da mensagem de ativação?</h5>
              <Alert variant="primary" className="mb-0">
              <Alert.Heading>{record.nome}</Alert.Heading>
                {record.email}
              </Alert>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={this.closeModal}>Cancelar</Button>
              <Button variant="success" onClick={this.handleSubmit}>Enviar</Button>
            </Modal.Footer>
            <CSSTransition
              in={isLoading}
              timeout={500}
              classNames="fade"
              unmountOnExit
            >
              <div><Loading /></div>
            </CSSTransition>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default ModalAtivacao;